import {Component, OnInit, HostListener, AfterViewInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";
declare var bootstrap: any;
@Component({
    selector: 'app-chancellor',
    templateUrl: './chancellor.component.html',
    styleUrls: ['./chancellor.component.scss']
})
export class ChancellorComponent implements OnInit {

    constructor(private meta: Meta,
                private titles: Title) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI’s Chancellor: Guiding Vision and Leadership\n');
        this.meta.updateTag({
            name: 'description',
            content: `Meet ARNI’s Chancellor, a visionary leader inspiring growth, innovation, and excellence. Discover their role in shaping the institution’s success.`
        });
    }
}
